import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d66f422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-6" }
const _hoisted_2 = { class: "card p-4" }
const _hoisted_3 = { class: "app-icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "app-text",
  "data-testid": "display-name"
}
const _hoisted_7 = { class: "controller-name" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "app-sub-text",
  "data-testid": "origin"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "controller-balance mt-4" }
const _hoisted_12 = { class: "txt" }
const _hoisted_13 = { class: "app-value" }
const _hoisted_14 = {
  key: 1,
  "data-testid": "app-balance",
  class: "profile-balance"
}
const _hoisted_15 = {
  class: "amount is-flex is-align-items-center",
  "data-testid": "amount"
}
const _hoisted_16 = { class: "icon-button" }
const _hoisted_17 = { class: "symbol ml-2" }

import { useI18n } from 'vue-i18n'
import { padLeft, stripHexPrefix, numberToHex, padRight } from 'web3-utils'
import { ERC725YDataKeys } from '@lukso/lsp-smart-contracts'
import { useRoute, useRouter } from 'vue-router'
import { computed, ref, onMounted, watch } from 'vue'
import makeBlockie from 'ethereum-blockies-base64'
import Scrollbar from 'smooth-scrollbar'
import browser from 'webextension-polyfill'

import { LUKSO_MAINNET_ID } from '@/shared/NetworkUtils'
import { useAppStore } from '@/popup/store/AppStore'
import Permissions from '@/popup/components/shared/ControllerPermissions/Permissions.vue'
import PermissionChangeModal from '@/popup/components/Modal/PermissionChangeConfirmation.vue'
import ShowControllerInteractionsPermissions from '@/popup/components/Modal/ShowControllerInteractionsPermissions.vue'
import RenameController from '@/popup/components/Modal/RenameController.vue'
import PermissionsBlock from '@/popup/components/shared/ControllerPermissions/PermissionsBlock.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import UserName from '@/popup/components/shared/Miscellaneous/UserName.vue'
import AccountWizard from '@/popup/components/shared/Wizard.vue'
import Notification from '@/popup/components/shared/Notification.vue'
import Scroll from '@/popup/components/shared/Scroll/Scroll.vue'
import Button from '@/popup/components/shared/Button.vue'
import { PermissionWhitelist } from '@/shared/Permissions'
import Icon3 from '@/assets/compass-outline.png'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'
import { PopupDatabase, saveLastState } from '@/popup/storage/Database'
import IconButton from '@/popup/components/shared/IconButton.vue'
import { SMART_CONTRACT_CONFIG } from '@/shared/SmartContractConfig'
import { useAppPermissionStore } from '@/popup/store/AppPermissionStore'
import { useNotifications } from '@/popup/compositions/useNotifications'
import UPIcon from '@/assets/up-icon.png'
import { DBNotifications } from '@/shared/apis/bgnotifications'
import { ToastType } from '@/shared/models/AppNotification'
import { ControllerDetailsEdit, NO_PERMISSIONS } from '@/shared/models/Profile'
import { getLevelPermissions } from '@/popup/utils/getLevelPermissions'
import Sanitize from '@/popup/components/shared/Sanitize.vue'
import Picture from '@/popup/components/shared/Picture.vue'
import ConfirmPermissionChanges from '@/popup/components/views/Home/ControllerDetail/ConfirmPermissionChanges.vue'
import { truncateMiddle } from '@/shared/utils'
import FundExtensionController from '@/popup/components/Modal/FundExtensionController.vue'
import { getControlLevelText } from '@/popup/utils/getControlLevelText'
import ModalTransition from '@/popup/components/shared/Modal/ModalTransition.vue'
import { ControllerDTO, PermissionName } from '@/business-logic/profile'
import FormattedTokenAmount from '@/popup/components/shared/FormattedTokenAmount.vue'
import { usePreferencesStore } from '@/popup/store/PreferencesStore'
import { checkIfUniversalReceiverAccount } from '@/shared/checkIfUniversalReceiverAccount'
import { useProfileStore } from '@/popup/store/ProfileStore'
import Skeleton from '@/popup/components/shared/Skeleton.vue'
import { FAUCET_URLS } from '@/shared/config'

import type {
  RestrictionCall,
  RestrictionSetData,
} from '@/shared/models/Restriction'

// TODO: There are three different ways of saving state: appStore.lastPopupState.appDetails, appPermissionStore, and
// saving directly to the database. We should refactor this to use only one method.


export default /*#__PURE__*/_defineComponent({
  __name: 'ControllerDetail',
  setup(__props) {

const appStore = useAppStore()
const router = useRouter()
const preferencesStore = usePreferencesStore()
const { createContract, getWeb3Eth } = useWeb3Eth()
const web3 = getWeb3Eth()
const appPermissionStore = useAppPermissionStore()
const notifications = useNotifications()
const { t } = useI18n({ useScope: 'global' })
const profileStore = useProfileStore()

const route = useRoute()
const controllerAddress = route.params['controllerAddress'] as string
const reason = route.query['reason'] as string

const controller = computed(() =>
  profileStore.getControllerByAddress(controllerAddress)
)

const deviceController = ref<ControllerDTO>()
watch(
  () => profileStore.deviceController,
  async newDeviceController => {
    deviceController.value = newDeviceController
  },
  { immediate: true }
)

const readOnlyMode = computed(
  () => deviceController.value?.permissions.controlLevel === 'None'
)

const { balance } = profileStore.getControllerBalance(controllerAddress)

const controllerDetails = appStore.lastPopupState?.appDetails

watch(
  controller,
  newController => {
    if (newController) {
      appPermissionStore.setPermissions(
        newController.permissions.activePermissions
      )
    }
  },
  { immediate: true }
)

const hasChanges = computed(() => appPermissionStore.hasChanges)

const hasSeenWarning = ref(false)
const permissionsScroll = ref<{
  element: HTMLElement
  instance: Scrollbar
  // eslint-disable-next-line unicorn/no-null
} | null>(null)
const interactionsRef = ref<InstanceType<typeof HTMLElement>>()

const isUniversalReceiverDelegate = ref(false)

const displayWarningMessage = ref(false)
const displayFundExtensionControllerModal = ref(false)
const displayRenameController = ref(false)

const levelPermissions = computed(() => {
  return getLevelPermissions(appPermissionStore.getAll())
})

const isExecuteOpen = ref(!!controllerDetails?.isExecuteOpen)
const isSetDataOpen = ref(!!controllerDetails?.isSetDataOpen)
const isExecutePermissionsOpen = ref(
  !!controllerDetails?.isExecutePermissionsOpen
)

const isEmptyPermissions =
  appPermissionStore.encodedPermissions === NO_PERMISSIONS

const saveState = async (activeExecutePermission?: PermissionWhitelist) => {
  const appDetails: ControllerDetailsEdit = {
    value: appPermissionStore.encodedPermissions,
    isExecuteOpen: isExecuteOpen.value,
    isSetDataOpen: isSetDataOpen.value,
    isExecutePermissionsOpen: isExecutePermissionsOpen.value,
    activeExecutePermission,
  }
  await saveLastState({
    path: router.currentRoute.value.path,
    appDetails,
  })
}

const closePermissionChangeWarning = async () => {
  displayWarningMessage.value = false
  if (!appStore.selectedProfile) {
    return
  }
  hasSeenWarning.value = true
  await PopupDatabase.put('hasSeenPermissionChangeWarning', {
    profileAddress: appStore.selectedProfile,
    hasSeenPermissionsChangeWarning: true,
  })
}

const closeFundExtensionControllerModal = () => {
  displayFundExtensionControllerModal.value = false
}

const changePermission = (key: string, isChecked: boolean) => {
  if (!hasSeenWarning.value) {
    displayWarningMessage.value = true
  }
  if (isChecked) {
    appPermissionStore.enable([key as PermissionName])
  } else {
    appPermissionStore.disable([key as PermissionName])
  }
  saveState()
}

const encodeValueParameter = (type: string, value: string[]) => {
  return value.length > 0 ? web3.abi.encodeParameter(type, value) : '0x'
}

const onSave = async () => {
  const address = stripHexPrefix(controllerAddress)
  const keys = []
  const values = []
  const changedAllowedTypes = appPermissionStore.changedTypes

  if (appPermissionStore.hasChanges) {
    keys.push(
      ERC725YDataKeys['LSP6']['AddressPermissions:Permissions'] + address
    )
    values.push(appPermissionStore.encodedPermissions)
  }

  const hasCallChanges = changedAllowedTypes.includes('CALL')
  if (hasCallChanges) {
    let allowedCalls = '0x'
    for (const restriction of appPermissionStore.restrictions.filter(
      ({ type }) => type === 'CALL'
    ) as RestrictionCall[]) {
      // calls, address, standard, fns
      // 32 bytes = 64 characters =>
      //   4 bytes for call type = 8 characters (bytes4)
      //   20 bytes for address = 40 characters (address)
      //   4 bytes for standard = 8 characters (bytes4)
      //   4 bytes for fns = 8 characters (bytes4)
      allowedCalls += `0020${stripHexPrefix(
        padLeft(numberToHex(restriction.calls), 8)
      )}${stripHexPrefix(padLeft(restriction.address, 20))}${stripHexPrefix(
        padRight(restriction.standard, 8)
      )}${stripHexPrefix(padRight(restriction.fns, 8))}`
    }
    keys.push(
      ERC725YDataKeys['LSP6']['AddressPermissions:AllowedCalls'] + address
    )
    values.push(allowedCalls)
  }

  if (changedAllowedTypes.includes('SETDATA')) {
    keys.push(
      ERC725YDataKeys['LSP6']['AddressPermissions:AllowedERC725YDataKeys'] +
        address
    )
    const setDataRestrictions = appPermissionStore.restrictions.filter(
      ({ type }) => type === 'SETDATA'
    ) as RestrictionSetData[]
    const setDataKeys = setDataRestrictions.map(({ key }) => key)
    values.push(encodeValueParameter('bytes[]', setDataKeys))
  }

  const payload = createContract(SMART_CONTRACT_CONFIG.abis.SET_DATA)
    .methods.setDataBatch(keys, values)
    .encodeABI()

  getWeb3Eth()
    .sendTransaction({
      from: appStore.currentProfile.address,
      to: appStore.currentProfile.address,
      data: payload,
    })
    .on('error', error => {
      const message = error?.message ?? t('app_detail.save_error')
      notifications.updateToast({
        id: appStore.currentProfile.address,
        message,
        profileAddress: appStore.currentProfile.address,
        method: DBNotifications.NOTIFICATION,
        system: false,
        type: ToastType.ERROR,
        isPersistent: false,
      })
    })

  saveLastState({
    path: '/home',
    restrictions: [],
    appDetails: undefined,
  })
}

const onControllerNameChange = async (newName: string) => {
  await profileStore.saveCustomControllerName(newName, controllerAddress)
  displayRenameController.value = false
}

const showInteractions = ref<undefined | number>(undefined)

const onReset = async () => {
  appPermissionStore.rollbackChanges()
  if (showInteractions.value) {
    onCloseInteractions()
  }
  await saveLastState({
    path: '/home',
    restrictions: [],
    appDetails: undefined,
  })
}

const isExtensionController = computed(
  () => controllerAddress === deviceController.value?.address
)

const controllerName = computed(() => {
  if (controller.value?.name) {
    return controller.value.name
  }
  if (isExtensionController.value) {
    return t('profile.create.authorized_apps.browser_extension_display_name')
  }
  return truncateMiddle(controllerAddress)
})

const fundMyController = () => {
  const networkId = appStore.network.id

  if (
    networkId === LUKSO_MAINNET_ID ||
    networkId === 'ethereum-mainnet' ||
    networkId === 'base-mainnet'
  ) {
    displayFundExtensionControllerModal.value = true
  } else {
    const url =
      FAUCET_URLS[networkId as keyof typeof FAUCET_URLS] ||
      FAUCET_URLS['testnet']
    if (url) {
      browser.tabs.create({ url })
    }
  }
}

const controllerIcon = computed(() => {
  if (isExtensionController.value) {
    return UPIcon
  }
  return controller.value?.icon || Icon3
})

const onOpenDetail = () => {
  showInteractions.value = permissionsScroll.value?.instance?.offset?.y || 0
}

const onCloseInteractions = () => {
  showInteractions.value = undefined
}

onMounted(async () => {
  if (!appStore.selectedProfile) {
    return
  }

  const hasProfileSeen = await PopupDatabase.getPermissionChangeWarning(
    appStore.selectedProfile
  )
  hasSeenWarning.value = !!hasProfileSeen?.hasSeenPermissionsChangeWarning

  isUniversalReceiverDelegate.value = await checkIfUniversalReceiverAccount(
    web3,
    appStore.selectedProfile,
    controllerAddress
  )
})

onMounted(() => {
  if (reason === 'for-funding') {
    fundMyController()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Scroll, {
        ref_key: "permissionsScroll",
        ref: permissionsScroll,
        class: "app-detail-wrapper scrollbar-wrapper"
      }, {
        default: _withCtx(() => [
          _createVNode(AccountWizard, {
            title: controllerName.value,
            progress: 0
          }, null, 8 /* PROPS */, ["title"]),
          _createVNode(IconButton, {
            class: "close-btn",
            onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/home')))
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (controller.value?.permissions)
                ? (_openBlock(), _createBlock(Permissions, {
                    key: 0,
                    "is-level0-enabled": 
              controller.value.permissions.anyProfileDataAndSignEnabled
            ,
                    "is-level1-enabled": 
              controller.value.permissions.anyAccountInteractionsAndExtensionsEnabled
            ,
                    "is-level2-enabled": 
              controller.value.permissions.anyAdministrationAndOwnershipEnabled
            
                  }, {
                    icon: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        (controllerName.value.startsWith('0x'))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(makeBlockie)(_unref(controllerAddress)),
                              class: "app-identicon"
                            }, null, 8 /* PROPS */, _hoisted_4))
                          : (_openBlock(), _createBlock(Picture, {
                              key: 1,
                              height: "24",
                              width: "24",
                              "picture-url": controllerIcon.value,
                              class: _normalizeClass({ 'up-ext': isExtensionController.value }),
                              size: 24,
                              "data-testid": "up-extension-icon"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: _unref(makeBlockie)(_unref(controllerAddress)),
                                  class: "up-identicon",
                                  "data-testid": "identicon"
                                }, null, 8 /* PROPS */, _hoisted_5)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["picture-url", "class"]))
                      ])
                    ]),
                    text: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            (controllerName.value.startsWith('0x'))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(controllerName.value), 1 /* TEXT */))
                              : (_openBlock(), _createBlock(UserName, {
                                  key: 1,
                                  "data-testid": "app-name",
                                  profile: {
                        name: controllerName.value,
                        address: _unref(controllerAddress),
                      },
                                  "max-width": 210,
                                  "has-at-sign": false,
                                  "has-slice-address": true
                                }, null, 8 /* PROPS */, ["profile"])),
                            _createVNode(SvgIcon, {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (displayRenameController.value = true)),
                              name: "edit",
                              height: "16",
                              width: "16",
                              class: "is-clickable ml-2"
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(Sanitize, {
                            html: 
                      _ctx.$t('app.controller_permissions.info', {
                        control: _ctx.$t(
                          _unref(getControlLevelText)(
                            controller.value.permissions.controlLevel
                          )
                        ),
                      })
                    
                          }, null, 8 /* PROPS */, ["html"])
                        ])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["is-level0-enabled", "is-level1-enabled", "is-level2-enabled"]))
                : _createCommentVNode("v-if", true),
              _createVNode(ClipboardCopy, {
                value: _unref(controllerAddress),
                "has-hover-text": false,
                class: "mt-2",
                placement: "top",
                locked: "",
                "offset-distance": "5"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    ref: "profilePictureRef",
                    type: "text",
                    readonly: "",
                    value: _unref(controllerAddress),
                    class: "form-control input-outline is-align-items-center address-input mt-1"
                  }, null, 8 /* PROPS */, _hoisted_10)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["value"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('app.controller_permissions.controller_balance')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_13, [
                  (!_unref(balance))
                    ? (_openBlock(), _createBlock(Skeleton, {
                        key: 0,
                        name: "loading-balance",
                        width: "81",
                        height: "28",
                        class: "ml-1",
                        "data-testid": "app-balance-pending"
                      }))
                    : (_unref(balance))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createVNode(FormattedTokenAmount, {
                            class: "icon-button",
                            decimals: 18,
                            amount: _unref(balance),
                            symbol: _unref(preferencesStore).token.symbol,
                            offset: "12"
                          }, {
                            default: _withCtx(({ amount, symbol }) => [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(amount), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_17, _toDisplayString(symbol), 1 /* TEXT */)
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["amount", "symbol"])
                        ]))
                      : _createCommentVNode("v-if", true),
                  (isExtensionController.value)
                    ? (_openBlock(), _createBlock(Button, {
                        key: 2,
                        class: "ml-2",
                        variant: "secondary",
                        size: "small",
                        onClick: fundMyController
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('app.controller_permissions.fund_controller.fund')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            (isUniversalReceiverDelegate.value)
              ? (_openBlock(), _createBlock(Notification, {
                  key: 0,
                  class: "mt-4",
                  type: "warning",
                  "has-icon": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)(
              'app.controller_permissions.changing_universal_receiver_permissions'
            )), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(PermissionsBlock, {
              onOnChange: changePermission,
              onOnOpenDetail: onOpenDetail,
              control: controllerName.value,
              icon: "permission-profiledata-auth",
              "action-icon": "sign",
              disabled: readOnlyMode.value,
              color: "var(--blue-75)",
              title: 
            _ctx.$t(
              'app.controller_permissions.permissions_block.profile_data.title'
            )
          ,
              description: 
            _ctx.$t(
              'app.controller_permissions.permissions_block.profile_data.description'
            )
          ,
              permissions: levelPermissions.value.level0PermissionActions
            }, null, 8 /* PROPS */, ["control", "disabled", "title", "description", "permissions"]),
            _createElementVNode("div", {
              ref_key: "interactionsRef",
              ref: interactionsRef
            }, null, 512 /* NEED_PATCH */),
            _createVNode(PermissionsBlock, {
              onOnChange: changePermission,
              onOnOpenDetail: onOpenDetail,
              "action-icon": "account",
              disabled: readOnlyMode.value,
              control: controllerName.value,
              icon: "permission-account",
              color: "var(--yellow-75)",
              title: 
            _ctx.$t('app.controller_permissions.permissions_block.account.title')
          ,
              description: 
            _ctx.$t(
              'app.controller_permissions.permissions_block.account.description'
            )
          ,
              permissions: levelPermissions.value.level1PermissionActions
            }, null, 8 /* PROPS */, ["disabled", "control", "title", "description", "permissions"]),
            _createVNode(PermissionsBlock, {
              onOnChange: changePermission,
              onOnOpenDetail: onOpenDetail,
              disabled: readOnlyMode.value,
              control: controllerName.value,
              class: _normalizeClass(hasChanges.value ? 'add-padding' : 'mb-6'),
              icon: "permission-admin",
              "action-icon": "admin",
              color: "var(--red-75)",
              title: 
            _ctx.$t('app.controller_permissions.permissions_block.admin.title')
          ,
              description: 
            _ctx.$t('app.controller_permissions.permissions_block.admin.description')
          ,
              permissions: levelPermissions.value.level2PermissionActions
            }, {
              default: _withCtx(() => [
                _createVNode(Notification, {
                  class: "mb-4 mt-4",
                  type: "warning",
                  "has-icon": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('app.controller_permissions.permissions_block.admin.warning')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "control", "class", "title", "description", "permissions"]),
            isEmptyPermissions
              ? (_openBlock(), _createBlock(Notification, {
                  key: 1,
                  class: "mt-4",
                  type: "warning",
                  "has-icon": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('app.controller_permissions.removing_all_permissions')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 1 /* STABLE */
      }, 512 /* NEED_PATCH */),
      _createVNode(_Transition, { name: "slide" }, {
        default: _withCtx(() => [
          (hasChanges.value)
            ? (_openBlock(), _createBlock(ConfirmPermissionChanges, {
                key: 0,
                onOnReset: onReset,
                onOnConfirm: onSave
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(ModalTransition, null, {
        default: _withCtx(() => [
          (showInteractions.value !== undefined)
            ? (_openBlock(), _createBlock(ShowControllerInteractionsPermissions, {
                key: 0,
                "controller-name": controllerName.value,
                "read-only-mode": readOnlyMode.value,
                "permission-levels": levelPermissions.value.level3PermissionActions,
                onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/home'))),
                onOnChangePermission: changePermission,
                onOnCloseInteractions: onCloseInteractions
              }, null, 8 /* PROPS */, ["controller-name", "read-only-mode", "permission-levels"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(ModalTransition, null, {
        default: _withCtx(() => [
          (displayRenameController.value)
            ? (_openBlock(), _createBlock(RenameController, {
                key: 0,
                "controller-name": controller.value?.name,
                "profile-address": _unref(appStore).selectedProfile,
                onOnSubmit: onControllerNameChange,
                onOnCancel: _cache[3] || (_cache[3] = ($event: any) => (displayRenameController.value = false))
              }, null, 8 /* PROPS */, ["controller-name", "profile-address"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(ModalTransition, null, {
      default: _withCtx(() => [
        (displayWarningMessage.value)
          ? (_openBlock(), _createBlock(PermissionChangeModal, {
              key: 0,
              onOnClose: closePermissionChangeWarning
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(ModalTransition, null, {
      default: _withCtx(() => [
        (displayFundExtensionControllerModal.value)
          ? (_openBlock(), _createBlock(FundExtensionController, {
              key: 0,
              address: _unref(controllerAddress),
              onOnClose: closeFundExtensionControllerModal
            }, null, 8 /* PROPS */, ["address"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}
}

})